import FieldType from '@/shared/components/forms/WaveUIForm_V2/types/fieldType.enum';
import FormField from '@/shared/components/forms/WaveUIForm_V2/types/formField.type';

const useMetadataFormValidation = () => {
  const onFormValidate = (forms: FormField[][]) => {
    let errors: { field_name: string; error: string }[] = [];

    errors = forms.flat().map((form) => {
      if (
        form.field_type !== FieldType.Switch &&
        'required' in form.field_props &&
        form.isVisible &&
        form.field_props.required &&
        !form.field_props.value
      ) {
        return {
          field_name: form.field_props.name,
          error: 'Field is required',
        };
      }

      if (
        form.field_type === FieldType.Number &&
        'required' in form.field_props &&
        form.isVisible &&
        form.field_props.required &&
        parseInt(form.field_props.value as string) <= 0
      ) {
        return {
          field_name: form.field_props.name,
          error: 'Field is required',
        };
      }

      return {
        field_name: form.field_props.name,
        error: '',
      };
    });

    return {
      isValid: !errors.some((error) => error.error !== ''),
      errors,
    };
  };

  const updateFormFieldsErrors = (
    errors: { field_name: string; error: string }[],
    formsList: FormField[][],
  ) => {
    return formsList.map(
      (subArray) =>
        subArray.map((item) => {
          const error = errors.find(
            (err) => err.field_name === item.field_props.name,
          );

          if (error && item.field_type !== FieldType.Switch) {
            return {
              ...item,
              field_props: {
                ...item.field_props,
                error: !!error.error,
                helperText: error.error,
              },
            };
          }

          return {
            ...item,
            field_props: {
              ...item.field_props,
              error: undefined,
              helperText: '',
            },
          };
        }) as FormField[],
    );
  };

  return {
    onFormValidate,
    updateFormFieldsErrors,
  };
};

export default useMetadataFormValidation;
